

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const RESETPASSWORDFOREMPLOYEE= createAsyncThunk(
  "resetPasswordForEmployee/resetPasswordForEmployee",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const resetPasswordForEmployeeSlice = createSlice({
  name: "resetPasswordForEmployeeSlice",
  initialState: {
    resetPasswordForEmployee: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfresetPasswordForEmployee: (state) => {
        state.resetPasswordForEmployee.loading = false
        state.resetPasswordForEmployee.error = false
        state.resetPasswordForEmployee.data = []
        state.resetPasswordForEmployee.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(RESETPASSWORDFOREMPLOYEE.fulfilled, (state, action) => {
      state.resetPasswordForEmployee = {
        ...state.resetPasswordForEmployee,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFOREMPLOYEE.pending, (state, action) => {
      state.resetPasswordForEmployee = {
        ...state.resetPasswordForEmployee,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDFOREMPLOYEE.rejected, (state, action) => {
      state.resetPasswordForEmployee = {
        ...state.resetPasswordForEmployee,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const resetPasswordForEmployeeAction = {
    RESETPASSWORDFOREMPLOYEE,
};

export { resetPasswordForEmployeeAction };
export default resetPasswordForEmployeeSlice.reducer;
export const {setInitialStateOfresetPasswordForEmployee} = resetPasswordForEmployeeSlice.actions
